import {
  SET_HOTEL_LABELS,
  UPDATE_HOTEL_LABELS,
  SET_METAPOLICIES,
  UPDATE_METAPOLICIES,
} from '../constants/hotel';

export const setHotelLabels = (payload) => ({
  type: SET_HOTEL_LABELS,
  payload,
});

export const updateHotelLabels = (payload) => ({
  type: UPDATE_HOTEL_LABELS,
  payload,
});

export const setMetapolicies = (payload) => ({
  type: SET_METAPOLICIES,
  payload,
});

export const updateMetapolicies = (payload) => ({
  type: UPDATE_METAPOLICIES,
  payload,
});
